import React from 'react';
import { Translation } from 'react-i18next';

import './CryptoLinksEmptyPlaceholder.css';

const CryptoLinksEmptyPlaceholder = () => (
  <Translation>
    {(t) => (
      <div className="crypto-links-empty-placeholder">
        <div className="image-wrapper" />
        <div className="text">
          {t("You haven't added any Crypto Links yet")}
        </div>
      </div>
    )}
  </Translation>
);

export default CryptoLinksEmptyPlaceholder;
